<template>
  <v-app-bar
    app
    dense
    height="64px"
    class="elevation-1 white"
    :class="{ amber: isXsScreen, 'darken-1': isXsScreen }"
  >
    <v-app-bar-nav-icon class="d-flex d-sm-none" @click.stop="toggleDrawer"></v-app-bar-nav-icon>
    <v-toolbar-title>
      <v-img
        class="d-flex d-sm-none"
        src="../../assets/logo.svg"
        height="32px"
        width="132px"
        contain
      ></v-img>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <user
        v-if="['manager', 'accountant', 'super_admin', 'education_manager'].includes(role.type)"
        @changePassword="dialog = !dialog"
      />
      <student v-if="role.name === 'Student'" @changePassword="dialog = !dialog" />
      <teacher v-if="role.name === 'Teacher'" @changePassword="dialog = !dialog" />
    </v-toolbar-items>
    <ChangePasswordDialog :state="dialog" />
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex'
import User from '@/components/basic/menu/User'
import Teacher from '@/components/basic/menu/Teacher'
import Student from '@/components/basic/menu/Student'
import ChangePasswordDialog from '@/modules/user/ChangePasswordDialog.vue'
export default {
  components: {
    Student,
    Teacher,
    User,
    ChangePasswordDialog
  },
  computed: {
    ...mapState('auth', ['user', 'role']),
    isXsScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  data() {
    return { drawer: true, dialog: false }
  },
  methods: {
    toggleDrawer: function () {
      this.drawer = !this.drawer
      this.$emit('toggle-drawer', this.drawer)
    }
  }
}
</script>

<style></style>
